const WHATSAPP_NUMBER = "551938184191";

export const BUSINESS = {
  name: "Ótica Danko",
  phoneDisplay: "+55 19 3818-4191",
  address: "Rua Conselheiro José Franco de Godoy, 60, Mogi Guaçu – SP",
  sloganStorefront: "Na Ótica Danko, qualidade vem antes do preço!",
  sloganLogo: "Valorizando e protegendo seus olhos",
};

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general: "Olá! Quero conhecer as opções da Ótica Danko.",
  exam: "Olá! Gostaria de consultar um horário para exame de vista.",
  help: "Olá! Preciso de ajuda com meus óculos.",
  sunglasses: "Olá! Quero tirar uma dúvida sobre óculos de sol.",
};

export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Rua+Conselheiro+Jos%C3%A9+Franco+de+Godoy,+60,+Mogi+Gua%C3%A7u+-+SP";

export const MAPS_EMBED_URL =
  "https://maps.google.com/maps?q=Rua+Conselheiro+Jos%C3%A9+Franco+de+Godoy,+60,+Mogi+Gua%C3%A7u,+SP&t=&z=16&ie=UTF8&iwloc=&output=embed";

export const GOOGLE_PROFILE_URL = "https://share.google/Nz0pBnupC1gsDfxpF";

// Verificado no perfil público do Google da loja
export const GOOGLE_RATING = { value: "5,0", count: 155 };

export const GOOGLE_HOURS = [
  { days: "Segunda a sexta", time: "09:00 às 18:00" },
  { days: "Sábado", time: "09:00 às 12:30" },
  { days: "Domingo", time: "Fechado" },
];

// Avaliações reais copiadas do perfil público do Google, sem reescrita
export const GOOGLE_REVIEWS = [
  {
    name: "Ana Maura",
    time: "há 3 meses",
    text: "Fui muito bem atendida e recebi explicações de cada lente que poderia adquirir para maior conforto ao usar os óculos. Recomendo de olhos fechados. Estou muito satisfeita com os novos óculos.",
  },
  {
    name: "João Carlos Barbosa",
    time: "há 3 meses",
    text: "A experiencia não poderia ser melhor. Atendimento fantástico, atenção aos detalhes e ao meu gosto pessoal. Muita variedade e preços excelentes. Recomendo com certeza!",
  },
  {
    name: "Josias Nascimento",
    time: "há 1 ano",
    text: "A ótica danco é excelente, as atendentes são super educadas e profissionais. Eu vim de outra cidade pra fazer um par de óculos e acabei fazendo 2 pares.",
  },
  {
    name: "Paola Pereira",
    time: null,
    text: "Ótimo atendimento, ótimo preço, ambiente aconchegante, são muitos prestativos.",
  },
  {
    name: "Thais de Melo",
    time: null,
    text: "Atendimento impecável, ótimos preços e prazo de entrega super rápido.",
  },
  {
    name: null,
    time: null,
    text: "Óculos lindos, sempre com as melhores opções para todos!!",
  },
];

// Galeria de vídeos: colocar os arquivos em /public/assets/videos e listar aqui
// (ex.: { src: "/assets/videos/oculos-sol-1.mp4", poster: "/assets/videos/capa-1.jpg", alt: "..." }).
// Enquanto a lista estiver vazia, a seção de vídeos não aparece na página.
export const VIDEOS = [];
